import { UserQueueSettings } from '../../interfaces/user-queue-settings';
import { LimitOffsetPaging } from '../paged-results/limit-offset-paging.model';

export class ProviderCallLogListSettings {
  filters: null;
  paging: LimitOffsetPaging = LimitOffsetPaging.empty;
}

export class ProviderCallLogQueueSettings extends ProviderCallLogListSettings implements UserQueueSettings {
  position: number;
}
